<template>
  <v-container fluid v-if="showModal">
    <v-divider class="mt-5 mb-3" />
    <h3 class="mb-5" ref="detailZinute">Pranešimas</h3>

    <div v-if="pageloading" class="text-center my-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div class="zinuteDataContainer" v-if="!pageloading">
      <template v-if="!isNauja">
        <v-row>
          <v-col cols="12" md="12">
            <el-switch label="Aktyvus" v-model="formData.zin_aktyvus" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <el-date-picker
              required
              label="Vaizdavimo data nuo"
              v-model="formData.zin_galioja_nuo_data"
            />
          </v-col>
          <v-col cols="12" md="3">
            <el-time-picker
              required
              label="Vaizdavimo laikas nuo"
              v-model="formData.zin_galioja_nuo_laikas"
            />
          </v-col>
          <v-col cols="12" md="3">
            <el-date-picker
              label="Vaizdavimo data iki"
              v-model="formData.zin_galioja_iki_data"
            />
          </v-col>
          <v-col cols="12" md="3">
            <el-time-picker
              label="Vaizdavimo laikas iki"
              v-model="formData.zin_galioja_iki_laikas"
            />
          </v-col>
        </v-row>
      </template>
      <v-row>
        <v-col cols="12" md="12">
          <el-textarea
            label="Pranešimo pavadinimas"
            required
            :counter="400"
            v-model="formData.zin_pavadinimas"
          />
        </v-col>
      </v-row>
      <template v-if="!isNauja">
        <v-row>
          <v-col cols="12" md="10">
            <el-autocomplete
              :required="zinuteRolesRequired"
              :items="zinuteRoles"
              multiple
              :readonly="visosRoles"
              label="Rolės, kurioms pranešimas bus rodomas"
              v-model="formData.zin_roles"
            />
          </v-col>
          <v-col cols="12" md="2" class="mt-2">
            <el-checkbox label="Visos rolės" v-model="visosRoles" />
          </v-col>
        </v-row>

        <v-expansion-panels v-model="bylaPanel" class="mb-0">
          <v-expansion-panel>
            <v-expansion-panel-header>
              Rinkmenos
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <admin-zinute-upload
                :zinute-id="formData.zin_id"
                :bylos="formData.bylos"
                :multiple="false"
                :instant="true"
                :max-dydis="rinkmenaDydis"
                @savedData="savedUpload"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-row class="mt-5">
          <v-col cols="12" md="9" class="pt-1">
            <span :class="`text-label ${editorClass}`">Pranešimo tekstas</span>
          </v-col>
          <v-col cols="12" md="3" class="mb-0 pt-0 text-right">
            <!-- <el-switch
              class="ma-0 pa-0"
              label="HTML kodas"
              v-model="showSource"
            /> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="pt-0 mb-3">
            <!-- <el-textarea
              v-show="showText"
              class="mb-1 mt-0 pt-0"
              label=""
              hide-details
              validate-key="tekstas"
              v-model="formData.zin_aprasymas"
            /> -->
            <vue-editor
              required
              class="mb-1"
              v-if="showEditor"
              :editorToolbar="customToolbar"
              v-model="formData.zin_aprasymas"
            ></vue-editor>

            <template>
              <div class="v-text-field__details">
                <div class="v-messages theme--light error--text" role="alert">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">{{ editorErrorText }}</div>
                  </div>
                </div>
                <div :class="`v-counter theme--light ${editorClass}`">
                  {{ editorCount }} / {{ editorMax }}
                </div>
              </div>
            </template>
          </v-col>
        </v-row>

        <v-expansion-panels v-model="previewPanel" class="mb-0">
          <v-expansion-panel>
            <v-expansion-panel-header>
              Peržiūra
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" md="10">
                  <h3 class="mt-2">{{ formData.zin_pavadinimas }}</h3>
                </v-col>
                <v-col cols="12" md="2" class="text-left">
                  {{ formData.zin_galioja_nuo_data }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="10">
                  <div v-html="zinutePreview" class="zinute-tekstas"></div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </div>

    <v-footer class="form-footer" v-if="!pageloading">
      <el-button primary @click.native="saveData()" :loading="loading"
        >Saugoti</el-button
      >
      <el-button @click.native="cancelData()" :loading="loading"
        >Atšaukti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import AdminZinuteUpload from './AdminZinuteUpload'
import math from '../../mixins/math'

export default {
  name: 'AdminZinuteDetail',
  components: { AdminZinuteUpload, VueEditor },
  mixins: [math],
  data() {
    return {
      formData: {},
      loading: false,
      pageloading: false,
      visosRoles: false,
      tempRoles: [],
      showSource: false,
      rinkmenaDydis: null,
      bylaPanel: null,
      previewPanel: null,
      editorSaving: false,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    value: Boolean,
    zinuteId: Number,
    zinuteRoles: Array,
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isNauja() {
      return this.zinuteId === 0 && !this.formData.zin_id
    },
    showText() {
      return false //this.showSource
    },
    showEditor() {
      return true //!this.showSource
    },
    zinuteRolesRequired() {
      return !this.visosRoles
    },
    customToolbar() {
      return [
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['image', 'link', 'clean'],
      ]
    },
    zinutePreview() {
      let aprasymas = this.formData.zin_aprasymas
      aprasymas = aprasymas
        ? aprasymas.replaceAll(
            'href="downloadRinkmena(',
            'class="zinute-rinkmena" href="#" onclick="downloadRinkmena('
          )
        : null

      const find =
        aprasymas &&
        aprasymas.match(/<a(.[^<]*)downloadFoto\('(.[^<]+)<\/a>/gim)

      if (find) {
        const newReplace = find.map(function(val) {
          val = val.replace(
            /<a(.[^<]*)downloadFoto\('/i,
            `<img src="${process.env.VUE_APP_BASE_API}zinute-foto/`
          )
          val = val.replace(/\/content(.[^<]+)<\/a>$/i, '/content" />')
          return val
        })

        aprasymas = find.reduce((acc, item, i) => {
          return acc.replace(item, newReplace[i])
        }, aprasymas)
      }

      return aprasymas
    },
    editorMax() {
      return 100000
    },
    editorCount() {
      if (!this.formData.zin_aprasymas) {
        return 0
      }
      return this.formData.zin_aprasymas.length
    },
    editorIsEmpty() {
      return !this.formData.zin_aprasymas && this.editorSaving && !this.isNauja
    },
    editorIsFull() {
      return this.editorCount > this.editorMax
    },
    editorError() {
      return this.editorIsEmpty || this.editorIsFull
    },
    editorErrorText() {
      if (this.editorIsEmpty) {
        return 'Laukas privalomas'
      }
      if (this.editorIsFull) {
        return `Viršytas simbolių skaičius ${this.editorMax}`
      }
      return ''
    },
    editorClass() {
      if (!this.editorError) {
        return
      }
      return 'error--text'
    },
  },
  watch: {
    visosRoles(val) {
      this.formData.zin_visos_roles = val
      if (val) {
        this.tempRoles = this.formData.zin_roles
        this.formData.zin_roles = []
        return
      }
      this.formData.zin_roles = this.tempRoles
    },
  },
  created() {
    window.downloadRinkmena = this.downloadRinkmena.bind(this)
    if (this.zinuteId !== null) {
      this.getData()
    }
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      if (this.isNauja) {
        this.formData = {}
        this.loading = false
        this.pageloading = false
        this.$nextTick(() => {
          this.$vuetify.goTo(this.$refs.detailZinute)
        })
        return
      }

      this.$axios
        .get(`admin/zinute/${this.zinuteId}`)
        .then(res => {
          this.formData = res.data.zinute
          this.visosRoles = this.formData.zin_visos_roles
          this.rinkmenaDydis = parseInt(res.data.rinkmena_dydis)
          this.$vuetify.goTo(this.$refs.detailZinute)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then(res => {
        this.editorSaving = true
        if (res && !this.editorError) {
          this.loading = true
          let data = {
            ...this.formData,
          }

          this.$axios
            .post(`admin/zinute`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              if (!this.isNauja) {
                this.closeZinute()
                return
              }

              this.$vuetify.goTo(this.$refs.detailZinute)
              this.formData = res.data.zinute
              this.visosRoles = this.formData.zin_visos_roles
              this.rinkmenaDydis = parseInt(res.data.rinkmena_dydis)

              this.updateList()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
              this.editorSaving = false
            })
        }
      })
    },
    closeZinute() {
      this.cancelData()
    },
    cancelData() {
      this.showModal = false
      this.$emit('resetZinute')
      this.updateList()
    },
    updateList() {
      this.$emit('updateList')
    },
    savedUpload(bylos) {
      this.formData.bylos = bylos
    },
    downloadRinkmena(zinuteID, bylaID, hash) {
      this.$axios
        .get(`zinute/${zinuteID}/${bylaID}/${hash}/content`, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          const contentDisposition = res.headers['content-disposition']
          let fileName = 'rinkmena'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(
              /filename="(.+)"|filename=(.+)/
            )
            if (fileNameMatch[1]) {
              fileName = fileNameMatch[1]
            }
            if (fileNameMatch[2]) {
              fileName = fileNameMatch[2]
            }
          }
          this.openFile(res.data, fileName)
        })
        .catch(err => {
          const errData = JSON.parse(Buffer.from(err.data).toString('utf8'))
          window._VMA.$emit('DATA_ERROR', errData.message)
        })
    },
    openFile(fileData, fileName) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', this.safeFileName(fileName))
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>
<style lang="scss">
.zinuteDataContainer {
  max-width: 1100px;
}
.zinute-tekstas {
  margin-bottom: 15px;
  p {
    margin: 0 0 3px 0;
    padding: 0;
  }
  img {
    max-width: 100%;
  }
  ol > li,
  ul > li {
    list-style-type: none;
  }
  li::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  ul > li::before {
    content: '\2022';
  }

  ol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
      list-9;
    counter-increment: list-0;
  }
  ol li.ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-1;
  }
  ol li.ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-2;
  }
  ol li.ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-3;
  }
  ol li.ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-4;
  }
  ol li.ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9;
    counter-increment: list-5;
  }
  ol li.ql-indent-6 {
    counter-reset: list-7 list-8 list-9;
    counter-increment: list-6;
  }
  ol li.ql-indent-7 {
    counter-reset: list-8 list-9;
    counter-increment: list-7;
  }
  ol li.ql-indent-8 {
    counter-reset: list-9;
    counter-increment: list-8;
  }
  ol li::before {
    content: counter(list-0, decimal) '. ';
  }
  ol li.ql-indent-1::before {
    content: counter(list-1, lower-alpha) '. ';
  }
  ol li.ql-indent-2::before {
    content: counter(list-2, lower-roman) '. ';
  }
  ol li.ql-indent-3::before {
    content: counter(list-3, decimal) '. ';
  }
  ol li.ql-indent-4::before {
    content: counter(list-4, lower-alpha) '. ';
  }
  ol li.ql-indent-5::before {
    content: counter(list-5, lower-roman) '. ';
  }
  ol li.ql-indent-6::before {
    content: counter(list-6, decimal) '. ';
  }
  ol li.ql-indent-7::before {
    content: counter(list-7, lower-alpha) '. ';
  }
  ol li.ql-indent-8::before {
    content: counter(list-8, lower-roman) '. ';
  }

  .ql-indent-1 {
    padding-left: 3em;
  }
  .ql-indent-2 {
    padding-left: 6em;
  }
  .ql-indent-3 {
    padding-left: 9em;
  }
  .ql-indent-4 {
    padding-left: 12em;
  }
  .ql-indent-5 {
    padding-left: 15em;
  }
  .ql-indent-6 {
    padding-left: 18em;
  }
  .ql-indent-7 {
    padding-left: 21em;
  }
  .ql-indent-8 {
    padding-left: 24em;
  }

  .ql-align-left {
    text-align: left;
  }
  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
  .ql-align-justify {
    text-align: justify;
  }
}
</style>
